import React from "react";
import { Table } from "react-bootstrap";
import { MdEdit, MdDelete } from "react-icons/md";

const BannerTable = ({ banners, onEdit, onDelete }) => {
    return (
        <Table responsive striped bordered hover className="business-list mt-3">
            <thead>
                <tr>
                    <th>ID</th>
                    <th>Image</th>
                    <th>Link Type</th>
                    <th>Link</th>
                    <th style={{ textAlign: "center" }}>Action</th>
                </tr>
            </thead>
            <tbody>
                {banners.length > 0 ? (
                    banners.map((banner) => (
                        <tr key={banner.id}>
                            <td>{banner.id}</td>
                            <td>
                                <img 
                                    src={banner.image} 
                                    alt="banner" 
                                    style={{ width: "60px", height: "60px", objectFit: "cover", borderRadius: "4px" }} 
                                />
                            </td>
                            <td>{banner.link_type}</td>
                            <td>{banner.link}</td>
                            <td>
                                <div className="edit-delete-business">
                                    <div className="edit">
                                        <MdEdit onClick={() => onEdit(banner)} />
                                    </div>
                                    <div className="delete">
                                        <MdDelete onClick={() => onDelete(banner)} />
                                    </div>
                                </div>
                            </td>
                        </tr>
                    ))
                ) : (
                    <tr>
                        <td colSpan="5" className="text-center">No Banners Found</td>
                    </tr>
                )}
            </tbody>
        </Table>
    );
};

export default BannerTable;